import { fetch } from '@ixigo/shell/fetch';

import type { OnboardResponse, OnboardResponseEnvelope } from '../types';

/**
 * Bank redirect for already-eligible users (CVP `userFlow === "ONBOARDING"`).
 * Skips the pincode + form flow and goes straight to bank-side onboarding via
 * a form-POST handoff (see `redirect-to-bank`). Empty request body. Unwraps
 * the `data` envelope.
 */
export async function submitOnboard(): Promise<OnboardResponse> {
	const response: OnboardResponseEnvelope = await fetch
		.post('fintech/v1/cbcc/onboard', { json: {} })
		.json();
	return response.data;
}
